<div class="d-flex justify-content-between align-items-center mb-2">
  <h6 class="loginHeadingText text-start pt-3 mb-0">OBJECTIVES / GOALS</h6>
  <div class="logo-wrapper">
    <img src="assets/images/export.png" class="w-30" alt="" (click)="exportObjectiveTxt()" title="Export to TXT">
    <p style="color:#0c9ef1;" class="mb-0" style="display:none">Export to TXT</p>
  </div>
</div>

<div class="container" [ngClass]="{'disabled-row': disableAfterReview}">
  <div *ngFor="let item of projectObjectives; let i = index" class="row mb-2">
    <div class="col align-self-center text-center pe-0">
      <img src="assets/images/plus_icon.svg" alt="" (click)="addObjectve(i+1)">
    </div>
    <div class="col-md-11 pe-0">
      <select class="form-select" aria-label="Default select example" [(ngModel)]="item.objectiveID" (ngModelChange)="onAnyFieldValueChange($event)" (change)="onSelectionChange(item.objectiveID, i)">
        <option [value]="0" selected disabled>Select</option>
        <option *ngFor="let objective of objectives" [value]="objective.objectiveID">{{ objective.objective }}</option>
      </select>
    </div>
    <div *ngIf="projectObjectives.length > 1" class="col align-self-center text-center">
      <img src="assets/images/close_mark.svg" alt="" (click)="removeObjective(i)">
    </div>
  </div>
</div>



